import { useHistory } from 'react-router-dom'
import { ViewHeader, Filter, Card, Table, Date, Pagination, Submit, Input, Help, useSubmit, useGet, TextArea, cashmoneyhelper } from '@enkla-gui'
import { icons } from '@config'
import { useState, useEffect } from 'react'

export default function RentAdjustmentCreate() {
  const history = useHistory()
  const [excludedEntityIds, setExcludedEntityIds] = useState(new Set())

  const { data: companies } = useGet({ endpoint: 'api/company' })
  const { data: types } = useGet({ endpoint: 'api/entity/types' })

  const { data: rentable_entities, setPage, setFilter, getFilter, sorting, setSorting } = useGet({ endpoint: 'api/rentadjustment/entities', filter: {} })
  const { register, error, loading, submit, control, setValue, watch } = useSubmit({
    endpoint: 'api/rentadjustment',
    success: _ => history.push(`/rentadjustment/overview`)
  })

  useEffect(() => {
    setExcludedEntityIds(new Set())
  }, [getFilter])

  return (
    <>
      <ViewHeader title='Hyresjustering' icon={icons.percent} subtitle='Skapa' return={{ link: '#!/rentadjustment/overview', title: 'Översikt' }} />
      <Filter filters={[
        {
          type: 'select',
          label: 'Objektstyp',
          key: 'type',
          values: types?.filter(c => c.rentable).map(c => ({
            value: c.id,
            label: c.name
          })) || []
        },
        {
          type: 'select',
          label: 'Företag',
          key: 'company',
          values: companies?.data?.map(c => ({
            value: c.id,
            label: c.name
          })) || []
        }
      ]} useFilter={_filter => setFilter({ ..._filter })} />
      <div class='row'>
        <Card
          buttons={{
            footer: [<Submit
              onSubmit={() => {
                const filterWithExcluded = {
                  ...getFilter,
                  excluded_entities: Array.from(excludedEntityIds)
                }
                setValue('filter', filterWithExcluded)
                submit()
              }}
              text='Skapa' sending={loading} />]
          }}>
          <div class='row mb-3'>
            <div class='col'>
              <Input controls={{ register }} name='rate' options={{ required: true }} label='Förändring (%)' type='number' error={error} />
            </div>
            <div class='col'>
              <Date label='Datum' placeholder="Om inget anges utförs justeringen direkt" controls={{ control }} name='scheduled_at' error={error} />
            </div>
          </div>
          <Table
            loadercount={15}
            rows={rentable_entities?.data}
            sorting={sorting}
            useSorting={sort => setSorting({ ...sort })}
            empty={{
              text: 'Du har inte skapat några uthyrningsbara objekt än',
              icon: 'fa-layer-group'
            }}
            functions={{
              getType: type => (
                <div class='icon-badge'>
                  <i class={`fas fa-fw ${type.icon}`} /> <span>{type.name}</span>{' '}
                </div>
              ),
              new_rent: fee => cashmoneyhelper.format(parseInt(fee + fee * (watch('rate') / 100))),
              select: entity => (
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    checked={!excludedEntityIds.has(entity.id)}
                    onChange={_ => {
                      const newExcluded = new Set(excludedEntityIds)
                      if (newExcluded.has(entity.id)) {
                        newExcluded.delete(entity.id)
                      } else {
                        newExcluded.add(entity.id)
                      }
                      setExcludedEntityIds(newExcluded)
                    }}
                  />
                </div>
              ),
              getStatus: entity =>
                entity.type.rentable ? <span class={`w-100 badge ${entity.rented ? 'bg-success' : 'bg-default'}`}>{entity.rented ? 'Uthyrd' : 'Vakant'}</span> : '',
            }}
            keys={['_this>function:select', 'name', 'fee>currency', 'fee>function:new_rent', 'company.name', '_this>function:getStatus', 'type>function:getType']}
            headers={[
              {
                class: 'min'
              },
              {
                key: 'name',
                value: 'Namn',
                sortable: true,
                class: 'min'
              },
              {
                class: 'min',
                value: 'Hyra'
              },
              {
                value: 'Ny hyra'
              },
              {
                value: 'Företag'
              },
              {
                value: 'Status',
                class: 'min'
              },
              {
                key: 'entity_type_id',
                value: 'Typ',
                sortable: true,
                class: 'min'
              },
            ]}
          />
          <Pagination data={rentable_entities} fetch={setPage} />
        </Card>
      </div>
    </>
  )
}
